module.exports = __webpack_public_path__ + "img/mobileScreenFeature-3-1.4093a11a.svg";